import { Menu as MuiMenu } from "@mui/material";
import styles from "./styles.module.css";
import { sxButtonMenu } from "./sxProps";

interface ButtonMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  children: any;
}

const Menu: React.FC<ButtonMenuProps> = ({ anchorEl, open, handleClose, children }) => {

  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      sx={sxButtonMenu}
      MenuListProps={{
        autoFocus: false,
        disableListWrap: true,
      }}
    >
      <div className={styles["div-user-menu-item"]}>
        {children}
      </div>
    </MuiMenu>
  );
}

export default Menu;